import { render, staticRenderFns } from "./RefereeDetails.vue?vue&type=template&id=0552fb28&scoped=true"
import script from "./RefereeDetails.vue?vue&type=script&lang=js"
export * from "./RefereeDetails.vue?vue&type=script&lang=js"
import style0 from "./RefereeDetails.vue?vue&type=style&index=0&id=0552fb28&prod&scoped=true&lang=css"
import style1 from "./RefereeDetails.vue?vue&type=style&index=1&id=0552fb28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0552fb28",
  null
  
)

export default component.exports